import React from 'react';
import { connect } from 'react-redux';

import isEqual from 'lodash/isEqual';
import uniq from 'lodash/uniq';
import values from 'lodash/values';
import get from 'lodash/get';

import { translate as t, ChipField } from 'admin-on-rest';
import {
  Table,
  TableHeader,
  TableRow,
  TableHeaderColumn,
  TableBody,
  TableRowColumn,
  CardTitle,
  Card,
} from 'material-ui';

import './styles.css';
import { getTranslationByLocale } from '../utils/TranslationUtils';

class IngredientListView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allergens: [],
      contents: '',
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      (this.state.allergens.length === 0 &&
        nextProps.allergens.length > 0 &&
        nextProps.record.ingredientList.length > 0) ||
      !isEqual(this.props.allergens, nextProps.allergens) ||
      !isEqual(this.props.record.ingredientList, nextProps.record.ingredientList)
    ) {
      this.setState({
        allergens: this.reduceAllergens(nextProps.record.ingredientList, nextProps.allergens),
        contents: this.concatContents(nextProps.record.ingredientList),
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      !isEqual(this.props.record, nextProps.record) ||
      !isEqual(this.props.choices, nextProps.choices) ||
      !isEqual(this.props.allergens, nextProps.allergens) ||
      !isEqual(this.state.allergens, nextState.allergens)
    );
  }

  reduceAllergens = (ingredients, allergens) =>
    ingredients
      .reduce((sum, val) => uniq([...(val.allergens || []), ...sum]), [])
      .map((allergen) => allergens.find((a) => a.name === allergen));

  concatContents = (ingredients) =>
    ingredients
      .map(
        (ingredient) =>
          `<strong>${ingredient.description}:</strong> ${ingredient.contents || this.props.translate('missingContents')}`
      )
      .join('\n');

  render() {
    const { record, translate } = this.props;
    const { allergens, contents } = this.state;

    return (
      <Card className="ingredient-list-builder">
        <CardTitle subtitle={translate('resources.products.fields.ingredientList')} />
        <Table fixedHeader selectable={false}>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow>
              <TableHeaderColumn>
                {translate('resources.products.fields.contents.description')}
              </TableHeaderColumn>
              <TableHeaderColumn>
                {translate('resources.products.fields.contents.supplier')}
              </TableHeaderColumn>
              <TableHeaderColumn>
                {translate('resources.products.fields.contents.supplierOrderId')}
              </TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody showRowHover displayRowCheckbox={false}>
            {record &&
              record.ingredientList &&
              record.ingredientList.map((ingredient) => (
                <TableRow key={ingredient.id}>
                  <TableRowColumn>{ingredient.description}</TableRowColumn>
                  <TableRowColumn>{ingredient.supplier}</TableRowColumn>
                  <TableRowColumn>{ingredient.supplierOrderId}</TableRowColumn>
                </TableRow>
              ))}
            {allergens.length > 0 && (
              <TableRow>
                <TableRowColumn colSpan="3" style={{ textAlign: 'center' }}>
                  <p>
                    <strong>{translate('resources.products.fields.allergens')}:&nbsp;</strong>
                  </p>
                  <p style={{ display: 'flex', flexFlow: 'row wrap', justifyContent: 'center' }}>
                    {allergens.map((allergen) => (
                      <ChipField
                        record={{
                          title: getTranslationByLocale(allergen.title, this.props.locale),
                        }}
                        source="title"
                      />
                    ))}
                  </p>
                </TableRowColumn>
              </TableRow>
            )}
            {contents.length > 0 && (
              <TableRow>
                <TableRowColumn colSpan="3" style={{ textAlign: 'left' }}>
                  <p>
                    <strong>{translate('resources.products.fields.contents')}:&nbsp;</strong>
                  </p>
                  <p
                    style={{
                      display: 'flex',
                      flexFlow: 'row wrap',
                      justifyContent: 'flex-start',
                      whiteSpace: 'pre-wrap',
                    }}
                  >
                    <div dangerouslySetInnerHTML={{ __html: contents }} />
                  </p>
                </TableRowColumn>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Card>
    );
  }
}

IngredientListView.defaultProps = {
  record: {},
};

export default connect((state) => ({
  allergens: values(get(state, 'admin.resources.allergens.data', [])),
}))(t(IngredientListView));
